<template>
  <div class="grid-x align-middle">
    <div class="cell shrink">
      <span v-html="$icons.get('sync', 'large spin')" style="padding-right:.3rem"></span>
    </div>
    <div class="cell auto">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    label: {
      type: String
    }
  }
}
</script>
